import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";

export const packingDashboardApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        getPackingOverview: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/packing-data/overview?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['packingOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        })
    }),
});

export const {
    useGetPackingOverviewQuery 
} = packingDashboardApi;
